import { render, staticRenderFns } from "./ASC_Trending.vue?vue&type=template&id=80d7a30a&scoped=true&"
import script from "./ASC_Trending.vue?vue&type=script&lang=js&"
export * from "./ASC_Trending.vue?vue&type=script&lang=js&"
import style0 from "./ASC_Trending.vue?vue&type=style&index=0&id=80d7a30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d7a30a",
  null
  
)

export default component.exports